import classNames from "classnames";

import AscParagraph from "../AscTypography/AscParagraph/AscParagraph";
import AscLink from "../AscLink/AscLink";
import AscButton from "../AscButton/AscButton";
import styles from "./AscEmptyList.module.scss";
import { ReactComponent as EmptyIllustration } from "../../assets/illustrations/woman_empty_illustration.svg";
import { CSSProperties } from "react";

export interface AscEmptyListProps {
  title: string;
  subtitle?: string;
  redirectText?: string;
  redirectUrl?: string;
  className?: string;
  fillHeight?: boolean;
  fillWidth?: boolean;
  style?: CSSProperties;
}

export default function AscEmptyList({
  title = "Oops",
  subtitle,
  redirectText = "Redirect",
  redirectUrl,
  className,
  fillWidth = false,
  fillHeight,
  style,
}: AscEmptyListProps) {
  return (
    <div
      className={classNames(
        styles.emptyContainer,
        { [styles.fillWidth]: fillWidth, [styles.fillHeight]: fillHeight },
        className
      )}
      data-testid="asc-empty-list"
      style={style}
    >
      <EmptyIllustration className={styles.emptyIllustration} />
      <h3 className={styles.emptyTitle}>{title}</h3>
      {subtitle && (
        <AscParagraph className={styles.emptyDescription}>
          {subtitle}
        </AscParagraph>
      )}
      {redirectText && redirectUrl && (
        <AscLink innerWrapperTag="button" href={redirectUrl}>
          {redirectText}
        </AscLink>
      )}
    </div>
  );
}
